import React, { useState } from 'react';
import {styled} from 'linaria/react'
import { BrightStar, Check, MailOpened, NavArrowRight, SendDiagonal } from 'iconoir-react';
import RenderCustomElements from '../../CustomElements/RenderCustomElements';
import { theme } from '../../Theme';
import VbInformationBox from '../../Core/Form/VbInformationBox';
import SiteButton from '../../Core/SiteButton';
import { useIntl } from '@jetshop/intl';
import NewsletterWelcomeWidget from './NewsletterWelcomeWidget';

const NewsletterWelcomeContainer = styled.div`
   & > div:first-child {
      margin-top: 8rem;
   }

   & > div:last-child {
      margin-bottom: 8rem;
   }

   & > div {
      margin-bottom: 4rem;
   }
`

const SvgWrapper = styled.div`
    height: 42px;
    width: 42px;

    svg {
      height: 100%;
      width: 100%;
    }

    ${theme.below.md}{
      height: ${props => (props.mobileHeight)};
      width: ${props => (props.mobileWidth)};
    }
`

const NewsletterWelcomePage = ({ category }) => {
   const items = category?.data?.items
   const t = useIntl()

   return (
      <>
         <NewsletterWelcomeContainer className="p-0 container d-flex flex-column align-items-center">
            <NewsletterWelcomeWidget></NewsletterWelcomeWidget>
         </NewsletterWelcomeContainer>
         <div className="container-fluid p-0">
            <RenderCustomElements items={items}></RenderCustomElements>
         </div>
      </>
   )
}
 
export default NewsletterWelcomePage;